/**
 * Quote forms that change with the service's form type: airport, tour, event or other.
 *
 * An element marked data-modes="airport tour" shows only for those types. Every input
 * inside a hidden one is disabled as well, so the browser neither validates nor sends
 * it. An input marked data-required-modes="airport" is required only for those types.
 * The server renders the first state the same way, so the page is right before this runs.
 */
const FIELDS = 'input, select, textarea, button';

/** Legacy service modes: "standard" (and the old transfer variants) are airport transfers, "multiday" is a tour. */
export function normaliseMode(mode) {
    switch (mode) {
        case 'tour':
        case 'multiday':
            return 'tour';
        case 'event':
            return 'event';
        case 'other':
            return 'other';
        default:
            return 'airport';
    }
}

const listOf = (value) => String(value || '').split(/\s+/).filter(Boolean);

export function applyFormMode(root, mode) {
    root.dataset.mode = mode;
    // Document order: an outer block is settled before the blocks inside it.
    root.querySelectorAll('[data-modes]').forEach((el) => {
        const on = listOf(el.dataset.modes).includes(mode) && !el.parentElement?.closest('[data-modes][hidden]');
        el.hidden = !on;
        const fields = el.matches(FIELDS) ? [el] : [...el.querySelectorAll(FIELDS)];
        fields.forEach((field) => { field.disabled = !on; });
    });
    root.querySelectorAll('[data-required-modes]').forEach((field) => {
        field.required = listOf(field.dataset.requiredModes).includes(mode);
    });
    root.dispatchEvent(new CustomEvent('form-mode:change', { detail: mode }));
}
